import { FC } from "react";
import { Span } from "../../../../components/Text/Text";
import { ProjectT } from "../../../../models/models";
import useQueryParams from "../../../../utils/hooks/useQueryParams";
import { categoryOptions } from "../../../../utils/helpers/categoryOptions";
import { clss } from "../../../../utils/helpers/styleHelpers";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../utils/constants";
import { UserRoleE } from "../../../../models/enums";
import { useAppSelector } from "../../../../store/hooks";
import { selectCurrentUser } from "../../../../store/selectors/authSelectors";
import { useTranslate } from "../../../../utils/hooks/useTranslate";
import AdvertiserName from "../../../CampaignList/AdvertiserName";
import BrandName from "../../../CampaignList/BrandName";
import AdAgencyName from "../../../CampaignList/AdAgencyName";

import styles from "./projectInfo.module.scss";

type ProjectInfoPropTypes = {
  item: ProjectT;
  isProjectView?: boolean;
  showMore?: boolean;
};

const ProjectInfo: FC<ProjectInfoPropTypes> = ({
  item,
  isProjectView,
  showMore,
}) => {
  const user = useAppSelector(selectCurrentUser);
  const { addQueryParam } = useQueryParams();
  const options = categoryOptions();
  const { t } = useTranslate();

  const handleClick = (category: number, searchText: string | number) => {
    addQueryParam({ filterType: options[category].value, filter: searchText });
  };

  return item && item?.Detailed ? (
    <div
      className={
        isProjectView ? styles.projectViewItemInfo : styles.projectItemInfo
      }
    >
      {isProjectView ? (
        <>
          {/* {isMobileOrTablet() && (
            <p>
              <Span>Campaign</Span>:{" "}
              <span className={styles.campaignLinkMobile}>
                <Link to={RoutesE.CAMPAIGNS + `/${item?.Campaign?.Id}`}>
                  {item?.Campaign?.Id + " " + item?.Campaign?.Name}
                </Link>
              </span>
            </p>
          )} */}
          <p>
            <AdvertiserName campaign={item.Detailed} langPostfix="En" />
          </p>
          <p>
            <BrandName campaign={item.Detailed} langPostfix="En" />
          </p>
          <p className={styles.adAgencyWrapper}>
            <AdAgencyName campaign={item.Detailed} />
          </p>
          <p>
            <Span>Broadcasting date</Span>:{" "}
            <span>{dayjs(item.BroadcastingDate).format(DATE_FORMAT)}</span>
          </p>
          {item?.DeliveryServiceDetailsViewModel?.OrderStatusName &&
            (user?.role === UserRoleE.GlobalAdmin ||
              user?.role === UserRoleE.AdvertisingAgency) && (
              <p className={styles.rightAlign}>
                <Span>Order status</Span>:{" "}
                <span>
                  {" "}
                  {t(item.DeliveryServiceDetailsViewModel.OrderStatusName)}
                </span>
              </p>
            )}
          {showMore && (
            <>
              <p>
                <Span>Post-Production</Span>:{" "}
                <span>{item.Detailed.PostProductionCompanyName}</span>
              </p>
              <p>
                <Span>Production Company</Span>:{" "}
                <span>{item.Detailed.ProductionCompanyName || t`NONE`}</span>
              </p>
              <p>
                <Span>Industry sector</Span>:{" "}
                <span>{item.Detailed.IndustryName}</span>
              </p>
              <p>
                <Span>Creation date</Span>:{" "}
                <span>{dayjs(item.CreationDateTime).format(DATE_FORMAT)}</span>
              </p>
              <p>
                <Span>Production location</Span>:{" "}
                <span>
                  {" "}
                  {item.ProductionLocationIsrael ? t`local` : t`abroad`}
                </span>
              </p>
              <p>
                <Span>Presentor/actor</Span>:{" "}
                <span>{item.ParticipantNames || t`NONE`}</span>
              </p>
              <p>
                <Span>Speaker name</Span>:{" "}
                <span>{item.SpeakerNames || t`NONE`}</span>
              </p>
              <p>
                <Span>Created by user</Span>:{" "}
                <span>{item.Detailed.CreatedByUserFullName}</span>
              </p>
            </>
          )}
        </>
      ) : (
        <>
          <p>
            <Span>Advertiser</Span>: <span> {item.AdvertiserName}</span>
          </p>
          <p className={clss([styles.rightAlign])}>
            <Span>Brand</Span>:{" "}
            <span
              className={clss([styles.searchable])}
              onClick={() => handleClick(2, item.BrandName)}
            >
              {" "}
              {item.BrandName}
            </span>
          </p>
          <p>
            <Span>Broadcasting date</Span>:{" "}
            <span> {dayjs(item.BroadcastingDate).format(DATE_FORMAT)}</span>
          </p>
          <p>
            <Span>Market category</Span>: <span> {item.sectorName}</span>
          </p>
          <p>
            <Span>Delivery number</Span>:{" "}
            <span
              className={clss([styles.searchable, styles.searchableLeft])}
              onClick={() => handleClick(11, item.Number)}
            >
              {item.Number}
            </span>
          </p>
          <p>
            <Span>Post production company</Span>:{" "}
            <span
              className={clss([styles.searchable, styles.searchableLeft])}
              onClick={() => handleClick(8, "")}
            >
              {" "}
              {item.PostProductionCompanyName}
            </span>
          </p>
          <p>
            <Span>Number of versions</Span>: <span> {item.VersionCount}</span>
          </p>
          <p className={styles.rightAlign}>
            <Span>Creation date</Span>:{" "}
            <span> {dayjs(item.CreationDateTime).format(DATE_FORMAT)}</span>
          </p>
        </>
      )}
    </div>
  ) : null;
};

export default ProjectInfo;
